<template>
  <div class="overflow-hidden full-width full-height">
    <div class="d-flex align-center">
      <div class="flex-grow-0 flex-shrink-0" style="width: 40px">
        <div v-if="loading" class="mx-2">
          <i class="mdi mdi-spin mdi-loading"></i>
        </div>
        <div v-else-if="item.style == 'legend'" class="mx-2">
          <v-icon class="mdi mdi-map-legend" size="24"></v-icon>
        </div>
        <div v-else-if="typeof item.style == 'string'" class="mx-2">
          <v-icon size="24">
            {{ item.style }}
          </v-icon>
        </div>
        <LegendMapboxFilter
          :layer="item.style"
          :item="item"
          v-else-if="item.style"
        />
      </div>
      <span
        class="text-caption d-inline-block text-truncate text-left flex-grow-1"
        :title="item.name"
        @click="$emit('click', item)"
      >
        <span>{{ item.name }}</span>
      </span>
      <div class="d-flex flex-grow-0 align-center">
        <base-button
          @click="onAction(menu)"
          v-for="(menu, i) in item.extra_buttons"
          :key="i"
          class="mr-2"
          icon
          small
          :disabled="loading"
          :tooltip="menu.tooltip"
          v-bind="menu.attr"
        >
          <v-icon small> {{ menu.icon }} </v-icon>
        </base-button>
        <base-button
          class="mr-2"
          icon
          small
          :disabled="loading"
          @click.stop="onToBounds"
          v-if="item.metadata.bounds"
        >
          <v-icon small> mdi-crosshairs-gps </v-icon>
        </base-button>
        <base-button
          class="mr-2"
          icon
          small
          :disabled="loading"
          :tooltip="isShow ? 'Ẩn lớp bản đồ' : 'Hiển lớp bản đồ'"
          @click.stop="toggleShow"
        >
          <v-icon v-if="isShow" small>mdi-eye</v-icon>
          <v-icon v-else small>mdi-eye-off</v-icon>
        </base-button>
        <base-button
          class="mr-2"
          icon
          small
          v-if="!readonly && !item.disable_delete"
          tooltip="Xóa lớp"
          @click.stop="onRemove"
        >
          <v-icon small>mdi-delete</v-icon>
        </base-button>
        <slot name="extra-btn" />
        <v-menu bottom left v-if="item.menus && item.menus.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small> mdi-dots-vertical </v-icon>
          </template>
          <v-list dense>
            <!-- <v-list-item @click="showFeatureList(item)">
                          <v-list-item-title
                            >Danh sách đối tượng</v-list-item-title
                          >
                        </v-list-item> -->
            <v-list-item
              :disabled="loading"
              @click="onAction(menu)"
              v-for="(menu, i) in menus"
              :key="i"
            >
              <v-list-item-title>
                {{ menu.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="d-flex align-center">
      <div class="flex-grow-1">
        <v-slider
          v-if="!item.disabled_opacity"
          v-model="opacity"
          dense
          height="20px"
          hide-details
          max="1"
          min="0"
          :disabled="loading"
          small
          :color="item.color"
          step="0.1"
          thumb-label
          :thumb-size="24"
        ></v-slider>
      </div>
      <div class="text-right flex-grow-0 flex-shrink-0" style="width: 40px">
        <div v-if="item.legend">
          <v-btn @click="onLegendShow" small icon>
            <v-icon small>
              {{ isLegendShow ? 'mdi-menu-up' : 'mdi-menu-down' }}
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div
      v-if="item.legend"
      v-show="isLegendShow"
      style="max-height: 100px"
      class="overflow-auto"
    >
      <LayerLegend :value="item.legend" :layer="item" />
    </div>
  </div>
</template>

<script>
import { get, set } from 'lodash'

import LayerLegend from './layer-legend.vue'
import LegendMapboxFilter from './LegendMapboxFilter.vue'

export default {
  components: { LayerLegend, LegendMapboxFilter },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        metadata: { loading: false, bounds: null },
        name: '',
        opacity: 1,
        show: true,
        legend_show: false,
        menus: [],
        disabled_opacity: false,
        disable_delete: false,
        legend: null,
        style: null,
        extra_buttons: [],
      }),
    },
    isCompare: Boolean,
    isSelected: Boolean,
    readonly: Boolean,
  },
  computed: {
    loading() {
      return this.item.metadata && this.item.metadata.loading
    },
    isShow() {
      return this.item.show
    },
    isLegendShow() {
      return this.item.legend_show
    },
    keyOpactiy() {
      return 'opacity'
    },
    opacity: {
      get() {
        return get(this.item, this.keyOpactiy, 1)
      },
      set(value) {
        let item = this.item
        set(item, this.keyOpactiy, value)
        this.$emit('update:item', item)
      },
    },
    menus() {
      return this.item.menus
    },
  },
  watch: {},
  methods: {
    toggleShow() {
      let item = this.item
      item.show = !item.show
      this.$emit('update:item', item)
    },
    onLegendShow() {
      let item = this.item
      item.legend_show = !item.legend_show
    },
    onToBounds() {
      this.$emit('click:bounds', this.item)
    },
    onRemove() {
      this.$emit('click:remove', this.item)
    },
    onAction(menu) {
      this.$emit('click:action', { menu, item: this.item })
    },
  },
}
</script>

<style scoped lang="scss">
.layer-item {
  position: relative;
  .draggable-handle {
    cursor: all-scroll;
    width: 20px;
    height: 100%;
  }
}
.layer-active {
  outline: 1px solid var(--v-primary-base) !important;
}
</style>
<style scoped>
:deep(.v-slider.v-slider--horizontal) {
  min-height: 20px;
}
</style>
